export default __webpack_public_path__ + "static/media/snehal-pic.38344462.png";